
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import callApi from '../util/callApi';
import { fetchUserDetails } from '../appActions';
import { toast } from 'react-toastify'; // Add this line
import { set } from 'react-hook-form';



function CheckoutForm({ setCloseModal, plan ,devices, totalPrice, additionalUsers,autoPayEnabled,freeTrialEligible}) {
  
  
  const state = useSelector((state) => state);
  const nav = useNavigate();
  const dispatch = useDispatch();
  const [orderCreated, setOrderCreated] = useState(false);

  useEffect(() => {
    
    dispatch(fetchUserDetails());
    
  }, []);

  useEffect(() => {
    if (!orderCreated && state?.user_det && autoPayEnabled && devices.length > 0) {
      setOrderCreated(true);
      initializeSubscription();
    }
    else if (!orderCreated &&state?.user_det && !autoPayEnabled ) {
      setOrderCreated(true);
      createOrder();
    }

  }, [ state,autoPayEnabled,devices,orderCreated]);
  
  
      // console.log('devices', devices);
      // console.log('plan', plan);
      // console.log('totalPrice', totalPrice);
      // console.log('additionalUsers', additionalUsers);
      // console.log('autoPayEnabled', autoPayEnabled);
  const initializeSubscription = async () => {
    try {
      const userId = state?.user_det._id;
      const user = state?.user_det;
      
      
     
      // Step 1: Check or Create Razorpay customer
      const razorUserResponse = await callApi('/create_or_get_user', 'post', { userId});
      if (razorUserResponse.status !== 'Success') throw new Error('Failed to initialize Razorpay user.');

      const razorpayCustomerId = razorUserResponse.data.customer_id;

      // // Step 3: Create Razorpay subscription with calculated delays
      
      const subResponse = await callApi('/create-subscription', 'post', {
        userId: userId,
        name: user.username,
        totalPrice: totalPrice,
        email: user.contact_email,
        planId: plan.id,
        devices: devices,
        customerId: razorpayCustomerId,
        freeTrialEligible: freeTrialEligible,
        
      });
      const subscriptionId = subResponse.data.subscription.id;
      const Key=subResponse.data.razorpay;


      

      const options = {
        key: Key, // replace with real key
        subscription_id: subscriptionId,
        name: 'Abhram Technologies',
        image: 'https://www.abhram.com/assets/images/icon.png',
        description: 'Subscription Payment for devices',
        handler: async function (response) {
          if (response && response.razorpay_payment_id) {
           await Subscribe(response, user,totalPrice);
    
          } 
          else {
            toast.error("Payment failed. Please try again.", {
              position: "bottom-center",
              autoClose: 3000,
            });
          }
        },
        theme: {
          color: '#3399cc',
        },
      };
  
      const rzp = new window.Razorpay(options);
      rzp.open();

    } catch (error) {
      console.error("Subscription Init Error:", error);
      alert(error.message || "Failed to initialize payment process.");
      window.location.reload();
      setCloseModal(false);

    }
  };


  const createOrder = async () => {
    try {
      if (freeTrialEligible){
        const res=await callApi('/subscribeFreeTrial','post',{
          email: state?.user_det.contact_email,
          name: state?.user_det.username,
          userId: state?.user_det._id,
          plan: plan,
          deviceId: devices,
        });
        console.log("Free Trial Response:", res);
        if (res.status === 'Success') {
          toast.success("Free trial activated! You can now use the devices.", {
            position: "bottom-center",
            autoClose: 1000,
          });
          setTimeout(() => {
            window.location.href = '/subscription_details';
            
          }, 1000); // slight delay after toast
        } else {
          alert("An error occurred. If money was deducted, please contact customer support.");
        }
      }
      else{
        const res = await callApi('/create-payment-intent','post', {
          devices: devices,
          email: state?.user_det.contact_email,
          name: state?.user_det.username,
          plan: plan,
          additionalUsers: additionalUsers||0,
        });
    
        const data = res; // ✅ Correct

        console.log("Order Response:", data);
    
        if (!data || data.error) {
          throw new Error(data.error || 'Failed to create payment order');
        }
    
        await handlePayment(data.orderId, data.amount,data.razorpay);
      }
    } catch (error) {
      console.error("Order Creation Error:", error);
      alert(error.message || "Failed to create order.");
      window.location.reload();
      setCloseModal(false);
    }
  };

  
 

  const handlePayment = async (orderId, amount, key) => {
    const User = state?.user_det;
    console.log('orderId', orderId);
    console.log('amount', amount);
    console.log('key', key);
  
    const options = {
      key: key,
      amount: amount , // Amount in paisa
      currency: 'INR',
      name: 'Abhram Technologies',
      description: 'Subscription Payment',
      order_id: orderId,
      image: 'https://www.abhram.com/assets/images/icon.png',
      handler: async function (response) {
        console.log("Payment Successful:", response);
  
        // Verify payment before subscribing
        
        const verificationResult = await verifyPayment(response);
        console.log("Verification Result:", verificationResult);
        if (verificationResult?.status === 'Success') {
          // Step 2: Subscribe if payment is verified
          await Subscribe(response, User, totalPrice);
        } else {
          alert("Payment verification failed. Please contact support.");
        }
       
      },
      theme: {
        color: "#121212",
      },
      modal: {
        escape: false,
        backdropclose: false,
      },
    };
  
    const razor = new window.Razorpay(options);
    razor.open();
    razor.on('payment.failed', function (response) {
      alert('Payment failed! Please try again.');
      window.location.reload();
      setCloseModal(false);
    });
  };
  
  // Function to verify payment with backend
  const verifyPayment = async (paymentResponse) => {
    try {
      const verificationResponse = await callApi('/verify-payment', 'post', {
        razorpay_payment_id: paymentResponse.razorpay_payment_id,
        razorpay_order_id: paymentResponse.razorpay_order_id,
        razorpay_signature: paymentResponse.razorpay_signature,
      });
  
      return verificationResponse;
    } catch (error) {
      console.error("Payment verification failed:", error);
      return { status: "Failed" };
    }
  };
  

  const Subscribe = async (paymentResponse,User,total) => {
    const email = User.contact_email;
    
    
    callApi('subscribe', 'post', {
      email: email,
      user: User,
      plan: plan,
      devices: devices,
      paymentId: paymentResponse.razorpay_payment_id,
      orderId: paymentResponse.razorpay_order_id,
      subscriptionId: paymentResponse.razorpay_subscription_id,
      additionalUsers:additionalUsers,
      total:total,
      autoPayEnabled: autoPayEnabled,
      freeTrialEligible: freeTrialEligible,
      
    }).then(async (res) => {
      if (res.status === 'Success') {
        toast.success("Payment successful! Activating your subscription... it may take a few minutes to reflect in your dashboard.", {
          position: "bottom-center",
          autoClose: 3000,
        });
        setTimeout(() => {
          window.location.href = '/subscription_details';
          
        }, 4000); // slight delay after toast
       
      } else {
        alert("An error occurred. If money was deducted, please contact customer support.");
      }
    });
  };

  return null; // No button needed, Razorpay opens automatically
}

export default CheckoutForm;

